import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect, useDispatch} from 'react-redux';
import {bindActionCreators} from 'redux';

import {find} from '../../../../lib/objectHelper';
import withIntl from '../../../../lib/withIntl';

import WizardHeader from '../../../../components/WizardHeader/WizardHeader';
import {TaskType, ProtocolEditorViewMode, Feedback} from '../../../../constants/dataEnum';

import {hideLoading, showLoading, showSnackbar} from '../../../../stores/actions/appStateAction';
import {showModal, hideModal} from '../../../../stores/actions/modalStateAction';
import {
  backHandler,
  cancelHandler,
  onFinishedBroadcastWizard,
} from '../../../../stores/business/taskListBroadcastBusiness';
import {setAllTaskIsSelected} from '../../../../stores/actions/cardStateAction';
import {globalAddUndoItem} from '../../../../stores/business/undoRedoBusinessAction';
import {setBroadcastTaskEditStep, setSelectedMenu} from '../../../../stores/actions/protocolEditorAction';
import {getBroadcastTaskByType} from '../../../../lib/broadcastHelper';

const mapStateToProps = (state) => {
  const {broadcastTaskEditStep} = state.protocolEditorState;

  return {
    cardStateCards: state.cardState.cards,
    cardStateTasks: state.cardState.tasks,
    protocolBroadcastTaskEditStep: broadcastTaskEditStep,
  };
};

const mapDispatchToProps = (dispatch) => ({
  appStateActionShowSnackbar: bindActionCreators(showSnackbar, dispatch),
  modalStateActionShowModal: bindActionCreators(showModal, dispatch),
  modalStateActionHideModal: bindActionCreators(hideModal, dispatch),
  taskListBroadcastBusinessBackHandler: bindActionCreators(backHandler, dispatch),
  taskListBroadcastBusinessCancelHandler: bindActionCreators(cancelHandler, dispatch),
  cardStateActionSetAllTaskIsSelected: bindActionCreators(setAllTaskIsSelected, dispatch),
  undoRedoBusinessActionGlobalAddUndoItem: bindActionCreators(globalAddUndoItem, dispatch),
  protocolEditorStateActionSetBroadcastTaskEditStep: bindActionCreators(setBroadcastTaskEditStep, dispatch),
  setProtocolEditorMode: bindActionCreators(setSelectedMenu, dispatch),
});

function BroadcastHeader({
  intl,
  cardStateCards,
  cardStateTasks,
  appStateActionShowSnackbar,
  modalStateActionShowModal,
  modalStateActionHideModal,
  taskListBroadcastBusinessBackHandler,
  taskListBroadcastBusinessCancelHandler,
  notifyBack,
  notifyCancel,
  notifyCancelEdit,
  notifyNext,
  headerRef,
  cardStateActionSetAllTaskIsSelected,
  undoRedoBusinessActionGlobalAddUndoItem,
  protocolBroadcastTaskEditStep,
  protocolEditorStateActionSetBroadcastTaskEditStep,
  setProtocolEditorMode,
}) {
  const dispatch = useDispatch();

  const isEdit = !!protocolBroadcastTaskEditStep;
  const selectedCard = find(cardStateCards, {isSelected: true});
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(false);

  const getTaskAspirateBroadcast = () => getBroadcastTaskByType(selectedCard, cardStateTasks, TaskType.ASPIRATE);
  const getTaskDispensesBroadcast = () => getBroadcastTaskByType(selectedCard, cardStateTasks, TaskType.DISPENSE) || [];

  const isIncompleteCard = () => {
    const firstDispenseTask = getTaskDispensesBroadcast()[0];

    return !firstDispenseTask || !firstDispenseTask?.volume;
  };

  useEffect(() => {
    const isIncomplete = isIncompleteCard();
    if (isIncomplete !== isNextButtonDisabled) {
      setIsNextButtonDisabled(isIncomplete);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [cardStateTasks]);

  const hideBackButton = () => (!getTaskAspirateBroadcast() && !getTaskDispensesBroadcast()?.length) || isEdit;
  const hideNextButton = () => !isEdit;

  const onBack = () => {
    taskListBroadcastBusinessBackHandler();
    notifyBack();
    // undoRedoBusinessActionGlobalAddUndoItem();
  };

  const onNext = async () => {
    dispatch(showLoading());
    dispatch(onFinishedBroadcastWizard());
    dispatch(hideLoading());

    notifyNext();
  };

  const onCancel = async () => {
    if (!selectedCard || isEdit) {
      if (!selectedCard || (isEdit && !isIncompleteCard())) {
        setProtocolEditorMode(ProtocolEditorViewMode.SIMPLE_TRANSFER);
      }

      if (isEdit && isIncompleteCard()) {
        setProtocolEditorMode(ProtocolEditorViewMode.SIMPLE_TRANSFER);
        notifyCancelEdit();
      } else {
        notifyCancel();
        cardStateActionSetAllTaskIsSelected(false);
      }

      await protocolEditorStateActionSetBroadcastTaskEditStep(null);
      undoRedoBusinessActionGlobalAddUndoItem();

      return;
    }

    const title = intl.formatMessage({id: 'protocolEditor.broadcast.cancelModal.title'});
    const text = intl.formatMessage({id: 'protocolEditor.broadcast.cancelModal.text'});
    const okButtonText = intl.formatMessage({id: 'protocolEditor.broadcast.cancelModal.okButton'});
    const cancelButtonText = intl.formatMessage({id: 'protocolEditor.broadcast.cancelModal.cancelButton'});
    const cancelSuccessMessage = intl.formatMessage({id: 'protocolEditor.broadcast.cancelModal.successMessage'});

    const modalOkHandler = () => {
      taskListBroadcastBusinessCancelHandler();
      setProtocolEditorMode(ProtocolEditorViewMode.SIMPLE_TRANSFER);
      protocolEditorStateActionSetBroadcastTaskEditStep(null);
      modalStateActionHideModal();
      appStateActionShowSnackbar(Feedback.SUCCESS, cancelSuccessMessage);
      notifyCancel();
      cardStateActionSetAllTaskIsSelected(false);
      // undoRedoBusinessActionGlobalAddUndoItem();
    };

    const modalCancelHandler = () => {
      setProtocolEditorMode(ProtocolEditorViewMode.BROADCAST);
      modalStateActionHideModal();
    };

    modalStateActionShowModal(
      title,
      text,
      [
        {className: 'btn-lg', style: 'primary', handlerClick: modalOkHandler, text: okButtonText},
        {className: 'btn-lg', style: 'secondary', handlerClick: modalCancelHandler, text: cancelButtonText},
      ],
      modalCancelHandler,
    );
  };

  const renderText = () => {
    let text = '';

    if (protocolBroadcastTaskEditStep) {
      switch (protocolBroadcastTaskEditStep) {
        case 1:
        // eslint-disable-next-line default-case-last, no-fallthrough
        default:
          text = 'Broadcast Guide - Click or swipe to define your broadcast source well(s).';
          break;
        case 2:
          text = 'Broadcast Guide - Click or swipe to define your well(s) destination.';
          break;
      }
    } else {
      const taskAspirate = getTaskAspirateBroadcast();

      if (!taskAspirate) {
        text = 'Broadcast Guide - Click or swipe to define your broadcast source well(s).';
      } else {
        text = 'Broadcast Guide - Click or swipe to define your well(s) destination.';
      }
    }

    return (
      <span className="header-text">
        <span className="header-text-title">{text}</span>
      </span>
    );
  };

  return (
    <div ref={headerRef}>
      <WizardHeader
        hideBackButton={hideBackButton()}
        hideNextButton={hideNextButton()}
        nextButtonText="APPLY"
        cancelButtonText="CANCEL"
        onBackClick={onBack}
        onNextClick={onNext}
        onCancelClick={onCancel}
        disableNextButton={isNextButtonDisabled}
      >
        {renderText()}
      </WizardHeader>
    </div>
  );
}

BroadcastHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  cardStateCards: PropTypes.object.isRequired,
  cardStateTasks: PropTypes.object.isRequired,
  appStateActionShowSnackbar: PropTypes.func.isRequired,
  modalStateActionShowModal: PropTypes.func.isRequired,
  modalStateActionHideModal: PropTypes.func.isRequired,
  taskListBroadcastBusinessBackHandler: PropTypes.func.isRequired,
  taskListBroadcastBusinessCancelHandler: PropTypes.func.isRequired,
  notifyBack: PropTypes.func,
  notifyCancel: PropTypes.func,
  notifyCancelEdit: PropTypes.func,
  notifyNext: PropTypes.func,
  headerRef: PropTypes.any,
  cardStateActionSetAllTaskIsSelected: PropTypes.func.isRequired,
  undoRedoBusinessActionGlobalAddUndoItem: PropTypes.func.isRequired,
  protocolBroadcastTaskEditStep: PropTypes.any,
  protocolEditorStateActionSetBroadcastTaskEditStep: PropTypes.func.isRequired,
  setProtocolEditorMode: PropTypes.func.isRequired,
};

BroadcastHeader.defaultProps = {
  notifyBack: () => {},
  notifyCancel: () => {},
  notifyCancelEdit: () => {},
  notifyNext: () => {},
  headerRef: null,
  protocolBroadcastTaskEditStep: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(BroadcastHeader));
